<template>
  <div class="solicitation-container">
    <div class="solicitation-header">
      <div class="solicitation-information">
        <div class="title-info">
          <span class="title">ID Solicitação:</span>
          <span class="info">{{ solicitation.id }}</span>
        </div>
        <div>
          <span class="title">Status:</span>
          <span class="info">{{ getSolicitationStatus() }}</span>
        </div>
      </div>
      <div class="expand-button">
        <button
          @click="areInvoicesVisible = !areInvoicesVisible"
          :class="[areInvoicesVisible ? 'is-down' : 'is-up']"
        >
          &#9002;
        </button>
      </div>
    </div>
    <div class="invoice-content">
      <invoice-return-tracking
        v-show="areInvoicesVisible"
        v-for="invoice in solicitation.invoices"
        :key="invoice.id"
        :invoice="invoice"
      />
    </div>
  </div>
</template>

<script>
import InvoiceReturnTracking from "@/components/home/return-tracking/InvoiceReturnTracking.vue";

export default {
  name: "Solicitation",
  components: {
    InvoiceReturnTracking
  },
  props: ["solicitation"],
  data() {
    return {
      solicitationStatus: "",
      areInvoicesVisible: false
    };
  },
  methods: {
    isItemPending(item) {
      return (
        item.status == "Em Análise" ||
        item.status == "Aguardando Criação de OI" ||
        item.status == "Aguardando data de coleta" ||
        item.status == "Aguardando Data de Coleta" ||
        item.status == "Aguardando Faturamento" ||
        item.status == "Em Trânsito"
      );
    },
    getSolicitationStatus() {
      const self = this;
      let status = "Encerrada";
      this.solicitation.invoices.forEach(invoice => {
        invoice.items.forEach(item => {
          if (self.isItemPending(item)) {
            status = "Em Aberto";
          }
        });
      });
      return status;
    }
  },
  created() {
    this.solicitationStatus = this.getSolicitationStatus();
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/_colors.scss";

.solicitation-container {
  border: 1px solid $grey4;
  box-shadow: 5px 5px 10px -6px black;
  background: $grey7;
  width: 53.75%;
  height: 90%;
  padding: 10px;
  margin: 20px;
  min-width: 700px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  flex-direction: column;

  .solicitation-header {
    display: flex;
    justify-content: space-between;

    .solicitation-information {
      display: flex;
      width: 96%;
      justify-content: space-between;
      align-items: center;

      div {
        margin: 0 10px;

        span,
        h4 {
          margin: 6px 0;
        }
      }

      .title-info {
        flex-direction: row;
      }

      .title,
      .info {
        font-weight: bold;
        margin: 5px;
      }
    }

    .expand-button {
      button {
        color: $grey1;
        width: 25px;
        height: 25px;
        outline: none;
        text-align: center;
        background: none;
        border: none;
        font-size: 20px;
        line-height: 25px;

        &:hover {
          cursor: pointer;
        }
      }
    }
  }

  .invoice-content {
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: center;
  }

  .title {
    color: $grey1;
  }

  .info {
    color: $orange1;
  }
}

.is-down {
  transform: rotate(270deg);
}

.is-up {
  transform: rotate(90deg);
}
</style>
